import React, { createContext, useContext, useState, ReactNode } from "react";

interface LoadingContextType {
  analyticsLoading: boolean;
  setAnalyticsLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [analyticsLoading, setAnalyticsLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ analyticsLoading, setAnalyticsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};
